var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    viewBox: "0, 0, 34, 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,34 C7.627,34 0,26.373 0,17 C0,7.627 7.627,0 17,0 C26.373,0 34,7.627 34,17 C34,26.373 26.373,34 17,34 z M21.7,19.529 C21.703,20.621 21.144,21.637 20.22,22.219 L18.23,23.479 C15.822,25.007 14.811,26.626 15.14,28.428 C15.31,29.354 15.692,29.966 16.314,30.302 C16.75,30.537 17.324,30.655 18.02,30.655 C18.458,30.655 18.943,30.605 19.464,30.512 C26.914,29.152 31.869,21.984 30.512,14.534 C29.32,8.002 23.643,3.262 17.016,3.262 C16.188,3.262 15.354,3.338 14.534,3.488 C10.947,4.133 7.766,6.186 5.702,9.19 C3.621,12.182 2.824,15.882 3.488,19.466 C3.781,21.085 4.363,22.638 5.208,24.05 C5.319,20.2 7.688,16.783 12.258,13.883 L21.7,7.9 L21.7,10.008 C21.704,11.1 21.144,12.117 20.22,12.698 C18.1,14.04 15.632,15.605 14.006,16.636 C9.746,19.339 7.976,22.276 8.586,25.624 C8.924,27.476 9.736,28.705 11.063,29.387 C11.41,29.553 11.768,29.707 12.13,29.846 C12.048,29.572 11.981,29.295 11.929,29.014 C11.198,25.011 14.002,22.297 16.479,20.725 C17.525,20.061 19.131,19.044 20.477,18.194 L21.697,17.42 L21.697,19.529 z",
    fill: "#000000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo_black.e3ca4b7b6473a6f72fc168a8a22594ef.svg";
export { ForwardRef as ReactComponent };